import React from 'react'

const IconPencil = ({ size = '16px', fill = '#3d3d3d' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 12 12"
  >
    <g clipPath="url(#clip0_19295_15298)">
      <path
        fill={fill}
        d="M10.476.516a1.594 1.594 0 0 0-2.252 0L.982 7.758a.4.4 0 0 0-.099.176l-.872 3.55a.375.375 0 0 0 .441.456l3.653-.77a.38.38 0 0 0 .188-.101l7.242-7.242a1.595 1.595 0 0 0 0-2.252zm-7.25 8.838 4.968-4.967.86.86-4.967 4.967zm-1.39-1.39 4.968-4.967.86.86-4.967 4.967zm5.498-5.497.463-.464 2.25 2.25-.463.464zM1.476 8.664l1.895 1.895-2.49.524zm9.528-5.367-.426.426-2.25-2.25.426-.426a.843.843 0 0 1 1.191 0l1.06 1.059a.845.845 0 0 1 0 1.191"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_19295_15298">
        <path fill="#fff" d="M0 0h12v12H0z"></path>
      </clipPath>
    </defs>
  </svg>
)

export default IconPencil
